import { render, staticRenderFns } from "./clip.vue?vue&type=template&id=2359dbc6&scoped=true"
import script from "./clip.vue?vue&type=script&lang=js"
export * from "./clip.vue?vue&type=script&lang=js"
import style0 from "./clip.vue?vue&type=style&index=0&id=2359dbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2359dbc6",
  null
  
)

export default component.exports